module.exports = __webpack_public_path__ + "static/media/customers.c774d3cf.png";